import ApiWebCallEvo, {
    API_URL_PURCHASE
} from "./calls/evo-api-call";

export default class PurchaseDataProvider {


    constructor() {
    }

    // /***
    //  *
    //  * @param params
    //  * @param headers
    //  */
    // public async sendData(params = {}, headers = {}) {
    //
    //     let apiCall = new ApiWebCallEvo(
    //         API_URL_PURCHASE,
    //         params,
    //         headers
    //     );
    //
    //     let res = await apiCall.makeCall();
    //
    //     return res;
    // }

    public async sendData(params = {}, headers = {}) {
        let apiCall = new ApiWebCallEvo(
            API_URL_PURCHASE,
            params,
            headers
        );

        try {
            let res = await apiCall.makeCall();

            // if (!res || typeof res !== "object") {
            //     throw new Error("Invalid response structure.");
            // }

            return res;
        } catch (error) {

            if (error instanceof Error) {
                return {
                    status: 'ERROR',
                    errors: [error.message || "Došlo ke chybě. Prosíme, akci zopakujte."],
                };
            }

            return {
                status: 'ERROR',
                errors: ["Došlo ke chybě. Prosíme, akci zopakujte."],
            };
        }
    }
}
